import { getType } from '@anm/helpers/saga/typesafe-actions';
import compose from 'lodash/fp/compose';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { fetchAsync } from '../../actions';
import { compareDates, setStatusesForProjects, sortProjects } from '../../helpers';
import { VideoFolderActions } from '../../types';

const fetchFolderReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(fetchAsync.request): {
      const params = action.payload;
      return {
        ...state,
        params,
        error: null,
        isError: false,
        isPending: true
      };
    }
    case getType(fetchAsync.success): {
      const folder = action.payload;
      const { projects, folders } = folder;
      const isRootFolder = !!folder.parentId;
      folder.name = isRootFolder ? folder.name : 'Projects';

      return {
        ...state,
        data: {
          ...folder,
          folders: folders.sort(compareDates),
          projects: compose(sortProjects, setStatusesForProjects)(projects)
        },

        isPending: false
      };
    }
    case getType(fetchAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        error,
        isError: true,
        isPending: false
      };
    }
    default:
      return state;
  }
};

export default fetchFolderReducer;
